import LocomotiveScroll from 'locomotive-scroll'
import { addClass, removeClass } from '../../utils'

import Home from '../../routes/home'

class Locomotive {
  constructor() {
    this.locoScroll = null
  }

  init() {
    const locoScroll = new LocomotiveScroll({
      el: document.querySelector('[data-scroll-container]'),
      smooth: true,
      lerp: 0.2,
      multiplier: 1.8,
      touchMultiplier: 3,
      smartphone: {
        smooth: true,
        direction: 'vertical',
      }
    })

    this.locoScroll = locoScroll

    const logo = document.querySelector('[data-logo]')
    this.locoScroll.on('scroll', ({ scroll }) => {
      if (!Home.isAlreadyEntered) return
      if (scroll.y >= 180) {
        addClass(logo, 'is-hidden')
      } else {
        removeClass(logo, 'is-hidden')
      }
    })
  }

  destroy() {
    this.locoScroll.destroy()
  }

  update() {
    this.locoScroll.update()
  }

  start() {
    this.locoScroll.start()
  }

  stop() {
    this.locoScroll.stop()
  }

  scrollTo({ target, options }) {
    this.locoScroll.scrollTo(target, options)
  }
}

export default new Locomotive()